import { storage } from '@debijenkorf/dbk-common';

export const KEY = 'recentItems';
export const MAX_ITEMS = 16;

type StorageData = {
  product: string[];
  variant: string[];
};

export const saveToStorage = (data: string[] | StorageData) => {
  const timestamp = new Date();
  timestamp.setDate(timestamp.getDate() + 30); // Expire 30 days from now
  storage.saveToCache(KEY, JSON.stringify(data), timestamp.getTime());
};

export const addKey = (recentKey: string) => {
  let storageData = storage.loadFromCache(KEY) || [];

  if (storageData.includes(recentKey)) {
    return;
  }

  storageData.unshift(recentKey);
  storageData = storageData.slice(0, MAX_ITEMS);

  saveToStorage(storageData);
};

export const loadFromStorage = (): StorageData =>
  storage.loadFromCache(KEY) ?? { product: [], variant: [] };

export const removeProductView = (productCode: string, storageData: StorageData) => {
  const currentProductIndex = storageData.product.indexOf(productCode);

  if (currentProductIndex > -1) {
    storageData.product.splice(currentProductIndex, 1);
    storageData.variant.splice(currentProductIndex, 1);
  }

  return storageData;
};

export const addProductView = (productCode: string, variantCode: string) => {
  let storageData = storage.loadFromCache(KEY) || { product: [], variant: [] };

  storageData = removeProductView(productCode, storageData);

  storageData.product.unshift(productCode);
  storageData.variant.unshift(variantCode);

  storageData.product = storageData.product.slice(0, MAX_ITEMS);
  storageData.variant = storageData.variant.slice(0, MAX_ITEMS);

  saveToStorage(storageData);
};

export const removeRecentlyViewedProduct = (productCode: string) => {
  const storageData = removeProductView(productCode, loadFromStorage());
  saveToStorage(storageData);
};
